import { IconButton } from '@mui/material';
import { DarkModeTwoTone, LightModeTwoTone } from '@mui/icons-material';

import { useTheme } from 'hooks/useTheme';

const ThemeSwitcher = () => {
  const { theme, saveTheme } = useTheme();

  const handleClick = (scheme) => {
    saveTheme({ scheme });
  };

  return (
    <>
      {theme.scheme === 'dark' && (
        <IconButton onClick={() => handleClick('light')}>
          <LightModeTwoTone className="text-primary" />
        </IconButton>
      )}
      {theme.scheme === 'light' && (
        <IconButton onClick={() => handleClick('dark')}>
          <DarkModeTwoTone className="text-primary" />
        </IconButton>
      )}
    </>
  );
};

export default ThemeSwitcher;
